import ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { debounce } from 'throttle-debounce';
import { BrowserEvents, MobileBreakpoint } from './constants';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

;(function($) {

	const mainController = new ScrollMagic.Controller();
	const mobileController = new ScrollMagic.Controller();
	const desktopController = new ScrollMagic.Controller();

	$(document).on(BrowserEvents.barba.enter, function() {

		//=====================================
		//	!---------- ANIMATIONS ----------
		//=====================================

		// ---------- Global ----------

		$('.animated-section:not(.clone)').each(function() {

			const self = $(this);

			const sectionScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: 0.8, reverse: false })
				.setClassToggle(this, 'active')
				.addTo(mainController);

			updateController(() => sectionScene.progress(1));

		});

		// ---------- Parallax ----------

		$('.parallax-section:not(.fixed-parallax-section):not(.large-image-section):not(.clone)').each(function() {

			const self = $(this);
			const image = self.find('.parallax-image');
			const speed = 50;
			const tween = new TimelineMax()
				.fromTo(image, 1, { y: '-' + speed + '%', ease: Linear.easeNone }, { y: speed + '%', ease: Linear.easeNone })

			const parallaxScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: "onEnter", duration: "200%" })
				.setTween(tween)
				.addTo(desktopController);

			updateController(() => parallaxScene.progress(0.5));

		});

		$('.large-image-section').each(function() {

			const self = $(this);
			const image = self.find('.parallax-image');
			const speed = 20;
			const tween = new TimelineMax()
				.fromTo(image, 1, { y: '-' + (speed * 0.9) + '%', ease: Linear.easeNone }, { y: (speed * 1.1) + '%', ease: Linear.easeNone })

			const parallaxScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: "onEnter", duration: "200%" })
				.setTween(tween)
				.addTo(desktopController);

			updateController(() => parallaxScene.progress(0.5));

		});

		$('.double-images-section').each(function() {

			const self = $(this);
			const leftImage = self.find('.image-column:nth-child(1),.image-column:nth-child(3)');
			const rightImage = self.find('.image-column:nth-child(2),.image-column:nth-child(4)');
			const speed = 50;

			const leftTween = new TimelineMax()
				.fromTo(leftImage, 1, { y: speed + 'px', ease: Linear.easeNone }, { y: '0px', ease: Linear.easeNone });

			const leftScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: "onEnter", duration: "200%" })
				.setTween(leftTween)
				.addTo(desktopController);

			const rightTween = new TimelineMax()
				.fromTo(rightImage, 1, { y: '-' + speed + 'px', ease: Linear.easeNone }, { y: '0px', ease: Linear.easeNone });

			const rightScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: "onEnter", duration: "200%" })
				.setTween(rightTween)
				.addTo(desktopController);

			updateController(() => {
				leftScene.progress(1);
				rightScene.progress(1);
			});

		});

		// ---------- Header ----------

		$('.header-wrapper').each(function() {

			const self = $(this);

			const headerScene = new ScrollMagic.Scene({ triggerHook: 'onEnter', offset: 1 })
				.on('enter', () => self.addClass('small'))
				.on('leave', () => self.removeClass('small'))
				.addTo(mainController);
		});

		// ---------- Controller ----------

		updateController(() => {
			desktopController.enabled(false);
			mobileController.enabled(true).update(true);
		}, () => {
			desktopController.enabled(true).update(true);
			mobileController.enabled(false);
		});

		$(window).trigger('resize');
	});

	// ---------- Functions ----------

	function updateController(mobile, desktop) {

		$(window).on('resize', debounce(200, function() {

			if(typeof mobile === 'function' && window.innerWidth < MobileBreakpoint) {
				mobile();
			}
			else if(typeof desktop === 'function' && window.innerWidth >= MobileBreakpoint) {
				desktop();
			}

		}));
	}

}(jQuery));
